import React from "react";

interface RatingBarProps {
  /** Marker position along the bar, 0–100. */
  value?: number;
  /** Bar height in px. */
  height?: number;
}

// Near-hard stops: each color holds a solid band, then blends over ~4%.
const GRADIENT =
  "linear-gradient(to right," +
  " #e8412c 0%, #e8412c 18%," +
  " #ef8b2c 22%, #ef8b2c 38%," +
  " #f4cf3f 42%, #f4cf3f 58%," +
  " #8dc63f 62%, #8dc63f 78%," +
  " #3fae49 82%, #3fae49 100%)";

/**
 * Horizontal gradient pill with a white circular marker positioned along it.
 * Display-only.
 */
const RatingBar: React.FC<RatingBarProps> = ({ value = 50, height = 16 }) => {
  const markerSize = height + 8;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height,
        borderRadius: height,
        background: GRADIENT,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: `${value}%`,
          transform: "translate(-50%, -50%)",
          width: markerSize,
          height: markerSize,
          borderRadius: "50%",
          background: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.35)",
        }}
      />
    </div>
  );
};

export default RatingBar;
